export enum WorkflowRunType {
    SingleRun = 'SingleRun',
    BatchRun = 'BatchRun',
}
